import axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import store from '../../redux/store';
import { LOGOUT } from '../../redux/actions/types';
import tokenStorage from "../tokenStorage";

export const http = axios.create({
  baseURL: '/api/',
});

export const AUTH_TOKEN = 'authtoken';

createAuthRefreshInterceptor(http, () => {

    if (!tokenStorage.getItem(AUTH_TOKEN)) {
        return;
    }

    return http
        .post('/auth/refresh')
        .then((tokenRefreshResponse) => {

            let token = tokenRefreshResponse?.data?.token;

            if (token) {
                tokenStorage.setItem(AUTH_TOKEN, token);
                return Promise.resolve();
            }

            throw new Error("Refresh failed!!");

        })
        .catch((err) => {
            tokenStorage.removeItem(AUTH_TOKEN);
            store.dispatch({ type: LOGOUT });
        });
});

http.interceptors.request.use((config) => {

    const token = tokenStorage.getItem(AUTH_TOKEN);

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});
